import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 查询合伙人列表
  getagents: option => {
    return request3('v1/agent/getagents', option, true)
  },
  // 查询合伙人信息
  getagent: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/getagent' + urls, {}, true)
  },
  // 设置合伙人的邀请人
  setagentinviter: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/setagentinviter' + urls, {}, true)
  },
  // 审核合伙人
  auditagent: option => {
    return request3('v1/agent/auditagent', option, true)
  },
  // 查询可绑定的追溯系统经销商列表
  getbindablezsdealers: option => {
    return request3('v1/agent/getbindablezsdealers', option, true)
  },
  // 删除合伙人
  deleteagent: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/deleteagent' + urls, {}, true)
  },
  // 取消关联追溯系统进销商,降级为普通用户合伙人
  unbindzsdealer: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/unbindzsdealer' + urls, {}, true)
  },
  // 关联追溯系统进销商，升级
  bindzsdealer: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/bindzsdealer' + urls, {}, true)
  },
  // 查询合伙人佣金规则
  getagentcommissionrule: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/getagentcommissionrule' + urls, {}, true)
  },
  // 设置合伙人佣金规则
  configagentcommissionrule: option => {
    return request3('v1/agent/configagentcommissionrule', option, true)
  },
  // 查询提现申请列表
  getcommissioncleanings: option => {
    return request3('v1/agent/getcommissioncleanings', option, true)
  },
  // 审批提现申请
  ackcommissioncleaning: option => {
    return request3('v1/agent/ackcommissioncleaning', option, true)
  },
  // 查询合伙人佣金记录列表
  getagentcommissions: option => {
    return request3('v1/agent/getagentcommissions', option, true)
  },
  // 查询合伙人佣金详细
  getagentcommission: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/getagentcommission' + urls, {}, true)
  },
  // 查询合伙人订单列表
  getagentorders: option => {
    return request3('v1/agent/getagentorders', option, true)
  },
  // 统计合伙人佣金信息
  sumagentcommission: option => {
    const urls = urlStringify(option)
    return request3('v1/agent/sumagentcommission' + urls, {}, true)
  }
}
